import React, {Component} from 'react';

import strings from 'strings';
import {updateStepData} from 'api';

import {
	no_numbers_trial,
	no_numbers_answers,
	nn_numbers_trial,
	nn_numbers_answers,
	no_older_version_numbers_trial,
	no_older_version_numbers_answers,
	nn_older_version_numbers_trial,
	nn_older_version_numbers_answers,
} from './assets';
import listen from 'assets/listen.png';
import {stopAllSounds, playSound, createHowl, playHowl} from 'utils/playSound';

import './styles.scss';
import {TYPES} from '../../constants/index';

class Trial extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = isNormingTest
					? nn_numbers_trial
					: nn_older_version_numbers_trial;
				this.answers_stuff = isNormingTest
					? nn_numbers_answers
					: nn_older_version_numbers_answers;
				break;

			case 'no':
			default:
				this.assets = isNormingTest
					? no_numbers_trial
					: no_older_version_numbers_trial;
				this.answers_stuff = isNormingTest
					? no_numbers_answers
					: no_older_version_numbers_answers;
				break;
		}
	}
	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
		if (newProps.stepData.answered && !this.props.stepData.answered) {
			this.playFeedback(newProps.currentStep, newProps.stepData.correct);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	playFeedback = (task, correct) => {
		stopAllSounds(); //  prevent overlap

		let src;

		if (task === 0) {
			src = correct
				? this.answers_stuff.correct1
				: this.answers_stuff.incorrect1;
		} else if (task === 1) {
			src = correct
				? this.answers_stuff.correct2
				: this.answers_stuff.incorrect2;
		} else if (task === 2) {
			src = correct
				? this.answers_stuff.correct3
				: this.answers_stuff.incorrect3;
		}

		if (!src) return;

		const sound = createHowl({
			src,
			onend: () => {
				sound.unload(); //  prevent memory leak

				setTimeout(() => {
					updateStepData({feedbackDone: true});
				}, 2000);
			},
		});

		playHowl(sound);
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
		const src = this.assets[sound];
		if (!src) return;

		playSound(src);
	};

	stopSounds = () => {
		stopAllSounds();
	};
	render() {
		const {testKeyType, ageGroup} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				{!isNormingTest && <p>{strings.wsn_test1}</p>}
			</div>
		);
	}
}
export default Trial;
